<template>
  <el-dialog title="Nhập kho" :visible="visible" class="responsive" width="560px" :close-on-click-modal="false"
    @close="handleClose">
    <ValidationObserver ref="form" v-slot="{ handleSubmit, invalid }">
      <form class="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Tên mặt hàng</label>
              <el-input :value="item?.name" disabled class="w-100 import-stock-readonly" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Số lượng tồn</label>
              <el-input :value="currentQuantityDisplay" disabled class="w-100 import-stock-readonly" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Số lượng nhập thêm <span class="text-danger">*</span></label>
              <ValidationProvider vid="quantity" name="Số lượng" rules="required|numeric|min_value:1"
                v-slot="{ errors, classes }">
                <el-input-number v-model="form.quantity" :min="1" class="w-100" :class="classes" />
                <div class="fv-plugins-message-container">
                  <div class="fv-help-block text-danger">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group preview-quantity">
              <label class="mb-1">Số lượng tồn mới</label>
              <div class="preview-value">
                <span v-if="hasValidQuantity" class="preview-number">{{ newQuantityPreview }}</span>
                <span v-else class="text-muted">-</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Ghi chú</label>
              <el-input v-model="form.note" type="textarea" :rows="3" placeholder="Ghi chú (không bắt buộc)"
                class="w-100" />
            </div>
          </div>
        </div>

        <footer class="d-flex justify-content-end pt-4">
          <button type="button" class="btn btn-secondary font-weight-bold mr-2" :disabled="submitting"
            @click="handleClose">Đóng</button>
          <button type="submit" class="btn btn-primary font-weight-bold" :disabled="invalid || submitting">
            <i v-if="submitting" class="fas fa-spinner fa-spin mr-1"></i>
            {{ submitting ? "Đang lưu..." : "Cập nhật kho" }}
          </button>
        </footer>
      </form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
export default {
  name: "ImportStockModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    submitHandler: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      form: {
        quantity: null,
        note: "",
      },
      submitting: false,
    };
  },
  computed: {
    currentQuantity() {
      const q = this.item?.quantity;
      return typeof q === "number" ? q : parseInt(q, 10) || 0;
    },
    currentQuantityDisplay() {
      return this.currentQuantity.toLocaleString("vi-VN");
    },
    hasValidQuantity() {
      return Number(this.form.quantity) > 0;
    },
    newQuantityPreview() {
      return this.currentQuantity + (Number(this.form.quantity) || 0);
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.syncForm();
        this.$nextTick(() => this.focusQuantityInput());
      } else {
        this.submitting = false;
      }
    },
    item: {
      handler() {
        if (this.visible) this.syncForm();
      },
      deep: true,
    },
  },
  methods: {
    syncForm() {
      this.form = {
        quantity: null,
        note: "",
      };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.reset();
      });
    },
    focusQuantityInput() {
      this.$nextTick(() => {
        const el = this.$refs.quantityInput;
        if (el && el.$el) {
          const input = el.$el.querySelector("input") || el.$el;
          if (input) input.focus();
        }
      });
    },
    handleClose() {
      this.form = { quantity: null, note: "" };
      this.submitting = false;
      if (this.$refs.form) this.$refs.form.reset();
      this.$emit("close");
    },
    async onSubmit() {
      if (this.submitting || !this.item) return;
      this.submitting = true;

      const payload = {
        itemId: this.item.id,
        quantity: Number(this.form.quantity) || 0,
        note: (this.form.note || "").trim(),
      };

      try {
        if (this.submitHandler && typeof this.submitHandler === "function") {
          await this.submitHandler(payload);
          this.$emit("submit", payload);
          this.handleClose();
        } else {
          this.$emit("submit", payload);
        }
      } catch (err) {
        if (err?.data?.data?.message_validate_form && this.$refs.form) {
          this.$refs.form.setErrors(err.data.data.message_validate_form);
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.import-stock-readonly>>>.el-input__inner {
  background-color: #f5f7fa;
  color: #606266;
  cursor: not-allowed;
}

.preview-quantity {
  background: #f8f9fa;
  border-radius: 0.25rem;
  padding: 0.75rem 1rem;
}

.preview-value {
  font-size: 1.125rem;
  font-weight: 600;
}

.preview-number {
  color: #2d3748;
}
</style>
